export default function Reducer(prevState, action){
    switch (action.type) {
        case "LOADING":
            return {
                ...prevState,
                loading: true,
            };
        case "LOADED": 
            return {
                ...prevState,
                document: action.document,
                loading: false,
            };
        default:
            throw new Error();
    }
}